import React from "react";
import { log } from "@/lib/log";

const API = process.env.REACT_APP_BACKEND_URL;

export class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() { return { hasError: true }; }

  componentDidCatch(error, info) {
    log.error("[ErrorBoundary]", error, info);
    try {
      fetch(`${API}/api/client-error`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: String(error?.message || error), page: window.location.pathname, stack: (info?.componentStack || "").slice(0, 400) }),
      }).catch(() => {});
    } catch (e) { log.warn("[ErrorBoundary] signalement impossible :", e); }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-brand-ink text-white flex items-center justify-center px-6" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <h1 className="font-serif text-3xl mb-4">Un imprévu technique est survenu.</h1>
          <p className="text-white/60 mb-8">L'équipe de l'Académie AETHERIS vient d'en être informée. Vous pouvez recharger la page ou revenir à l'accueil.</p>
          <a href="/" className="inline-block px-8 py-4 text-xs uppercase tracking-[0.2em] font-semibold text-brand-ink" style={{ backgroundColor: "#C9A84C" }}>Retour à l'accueil</a>
        </div>
      </div>
    );
  }
}
